<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

// (function() {
//     var language = navigator.language || navigator.browserLanguage || (navigator.languages ? navigator.languages[0] : "");

//     if (language === 'zh-CN') {
//         // window.location.href = 'https://www.fnirsi.cn/';
//       document.body.innerHTML = "<h1>403 Forbidden</h1><p>Access Denied: The website cannot be accessed.</p>";
//       document.body.style.textAlign = "center";
//       document.body.style.paddingTop = "100px";
//     }
// })();

// 等待DOM加载完成
document.addEventListener('DOMContentLoaded', function() {
  //语言添加zh-cn选项
  addZHCNLanguageBtn();
  //加载可收缩文本效果
  rendFoldContent();
  //渲染主页banner
  initBanner();
});

//在多语言下拉框中添加中文选项，重定向到 https://www.fnirsi.cn/
function addZHCNLanguageBtn() {
  document.querySelectorAll('#HeaderLanguageList').forEach(function(list) {
    let newElement = document.createElement('li');
    newElement.className = 'disclosure__item';
    newElement.tabIndex = -1;
    newElement.innerHTML = `
      <a role="button" class="link link--text disclosure__link d-flex flex-align-center focus-inset" 
         href="https://www.fnirsi.cn/" hreflang="zh-cn" lang="zh-cn" data-value="zh-cn">
        <span class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
            <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
            	<circle cx="45" cy="45" r="45" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(222,41,16); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>
            	<polygon points="25.78,27.66 22.93,18.9 20.09,27.66 10.85,27.66 18.32,33.09 15.47,41.87 22.93,36.44 30.4,41.87 27.55,33.09 35.02,27.66 " style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,222,0); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>
            	<polygon points="43.5,20.39 45.09,23.03 45.36,19.96 48.36,19.27 45.53,18.07 45.8,15 43.78,17.32 40.95,16.12 42.53,18.76 40.51,21.07 " style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,222,0); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>
            	<polygon points="51.81,31.5 53.25,28.77 56.29,29.3 54.14,27.09 55.58,24.38 52.82,25.73 50.67,23.52 51.11,26.57 48.35,27.92 51.38,28.45 " style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,222,0); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>
            	<polygon points="54.1,40.5 56.52,38.6 53.45,38.71 52.39,35.82 51.54,38.78 48.48,38.89 51.02,40.6 50.17,43.56 52.6,41.67 55.15,43.39 " style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,222,0); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>
            	<polygon points="45.43,47.63 45.57,44.56 43.65,46.96 40.77,45.88 42.46,48.44 40.54,50.85 43.51,50.03 45.2,52.61 45.34,49.53 48.31,48.72 " style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,222,0); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>
            </g>
          </svg>
        </span>
        <span class="text">zh-cn</span>
      </a>
    `;
    list.insertBefore(newElement, list.firstElementChild);
  });
}

function rendFoldContent1() {
  // 获取所有可折叠容器
  const containers = document.querySelectorAll('.fsi-fold-container');

  // 检查是否存在可折叠容器
  if (containers.length === 0) {
    // 如果没有可折叠容器，直接返回，不执行后续逻辑
    return;
  }
  // 为每个容器初始化
  containers.forEach(container => {
    // 确保容器内的必要元素存在
    const content = container.querySelector('.fsi-collapsible-content');
    const toggleBtn = container.querySelector('.fsi-toggle-btn');
    
    // 如果缺少必要元素，跳过当前容器
    if (!content || !toggleBtn) {
      return;
    }
    
    const btnText = toggleBtn.querySelector('.fsi-btn-text');
    const btnIcon = toggleBtn.querySelector('i');
    
    // 检查内容是否超过6行
    function checkContentHeight() {
      // 创建一个临时元素来测量实际高度
      const temp = document.createElement('div');
      temp.style.visibility = 'hidden';
      temp.style.position = 'absolute';
      temp.style.width = content.offsetWidth + 'px';
      temp.style.fontSize = window.getComputedStyle(content).fontSize;
      temp.style.lineHeight = window.getComputedStyle(content).lineHeight;
      temp.innerHTML = content.innerHTML;
      document.body.appendChild(temp);
      
      // 计算一行文本的高度
      const lineHeight = parseInt(window.getComputedStyle(content).lineHeight);
      // 6行文本的总高度
      const maxHeight = lineHeight * 6;
      
      // 如果内容高度超过6行，则显示按钮，否则隐藏
      if (temp.offsetHeight > maxHeight) {
        toggleBtn.style.display = 'flex';
      } else {
        toggleBtn.style.display = 'none';
      }
      
      document.body.removeChild(temp);
    }
    
    // 切换展开/收起状态
    function toggleContent() {
      if (content.classList.contains('line-clamp-10')) {
        // 展开内容
        content.classList.remove('line-clamp-10', 'fsi-fade-out');
        if (btnText) btnText.textContent = 'Show less';
        if (btnIcon) btnIcon.classList.add('rotate-180');
      } else {
        // 收起内容
        content.classList.add('line-clamp-10', 'fsi-fade-out');
        if (btnText) btnText.textContent = 'Show more';
        if (btnIcon) btnIcon.classList.remove('rotate-180');
      }
    }
    
    // 初始化检查
    checkContentHeight();
    
    // 绑定按钮点击事件
    toggleBtn.addEventListener('click', toggleContent);
    
    // 为每个容器添加窗口大小改变事件监听
    window.addEventListener('resize', checkContentHeight);
  });
};

function rendFoldContent() {
  const containers = document.querySelectorAll('.fsi-fold-container');
  if (containers.length === 0) return;

  containers.forEach(container => {
    const content = container.querySelector('.fsi-collapsible-content');
    const toggleBtn = container.querySelector('.fsi-toggle-btn');
    let buttonTextNode = null;
    const btnIcon = toggleBtn.querySelector('i');

    if (!content || !toggleBtn || !btnIcon) return;

    // 找到按钮文本节点
    for (const node of toggleBtn.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
        buttonTextNode = node;
        break;
      }
    }

    // 计算文本高度 - 支持不同行高
    function initContentHeight() {
      // 保存原始样式
      const originalMaxHeight = content.style.maxHeight;
      const originalClasses = content.className;

      // 创建测量容器，保持相同上下文
      const measureContainer = document.createElement('div');
      measureContainer.style.cssText = `
        position: absolute;
        visibility: hidden;
        width: ${content.offsetWidth}px;
        pointer-events: none;
      `;

      // 创建内容克隆
      const clone = content.cloneNode(true);
      clone.style.maxHeight = 'none';

      // 移除可能影响测量的类
      clone.className = clone.className.replace('line-clamp-10', '').trim();

      // 添加到测量容器并插入到DOM
      measureContainer.appendChild(clone);
      container.parentNode.insertBefore(measureContainer, container);

      // 强制重绘
      measureContainer.offsetHeight;
      // 计算完整高度
      const fullHeight = clone.scrollHeight;

      // 计算前6行的高度 - 使用Range API精确测量
      const range = document.createRange();
      range.setStart(clone, 0);

      let lineCount = 0;
      let previousHeight = 0;
      let tenLinesHeight = 0;
      const step = 1; // 每次增加的节点数
      let currentNode = 0;
      
      // 遍历节点计算行数
      while (currentNode < clone.childNodes.length && lineCount < 10) {
        range.setEndAfter(clone.childNodes[currentNode]);
        const currentHeight = range.getBoundingClientRect().height;
        
        // 检测新行
        if (currentHeight > previousHeight) {
          const newLines = Math.floor((currentHeight - previousHeight) / 16); // 估算行高
          lineCount += newLines > 0 ? newLines : 1;
          previousHeight = currentHeight;
        }
        
        currentNode += step;
      }
      
      // 如果找到了10行，记录高度
      if (lineCount >= 10) {
        tenLinesHeight = range.getBoundingClientRect().height;
      } else {
        // 内容不足10行
        tenLinesHeight = fullHeight;
      }
      
      // 清理临时元素
      container.parentNode.removeChild(measureContainer);
      
      // 恢复原始状态
      content.style.maxHeight = originalMaxHeight;
      content.className = originalClasses;

      // 存储计算结果
      content.dataset.tenLinesHeight = tenLinesHeight;
      content.dataset.fullHeight = fullHeight;

      // 设置初始状态
      if (fullHeight > tenLinesHeight) {
          content.classList.add('line-clamp-10');
          content.style.maxHeight = `${tenLinesHeight}px`;
          toggleBtn.style.display = 'flex';
      } else {
          content.classList.remove('line-clamp-10');
          content.style.maxHeight = '2000px';
          toggleBtn.style.display = 'none';
      }
    }

    // 切换展开/收起状态
    function toggleContent() {
      const isCollapsed = content.classList.contains('line-clamp-10');
      const tenLinesHeight = parseInt(content.dataset.tenLinesHeight);
      const fullHeight = parseInt(content.dataset.fullHeight);

      if (isCollapsed) {
        // 展开
        content.classList.remove('line-clamp-10');
        content.style.maxHeight = `${fullHeight}px`;
        if (buttonTextNode) buttonTextNode.textContent = ' Show less';
        btnIcon.classList.add('rotate-180');
      } else {
        // 收起
        content.classList.add('line-clamp-10');
        content.style.maxHeight = `${tenLinesHeight}px`;
        if (buttonTextNode) buttonTextNode.textContent = ' Show more';
        btnIcon.classList.remove('rotate-180');
      }
    }

    // 动画结束后处理
    content.addEventListener('transitionend', function() {
      if (!content.classList.contains('line-clamp-10')) {
        // 完全展开后移除限制，允许内容自然扩展
        content.style.maxHeight = '2000px';
      }
    });

    // 初始化和响应式处理
    let resizeTimeout;
    initContentHeight();
    
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(initContentHeight, 100);
    });
    
    toggleBtn.addEventListener('click', toggleContent);
  });
};

<!-- Home Banner JScode -->
const slideshow = document.getElementById("fsi-slideshow");
const pagination = document.getElementById("fsi-sl-pagination");
const prevBtn = document.getElementById("prev-btn");
const nextBtn = document.getElementById("next-btn");

let currentIndex = 1;
let intervalId;
let isAnimating = false;

// ===================== 创建 picture 元素 =====================
function createPictureElement(bannerItem) {
  const picture = document.createElement("picture");
  picture.className = "fsi-banner-picture";

  // Desktop source
  const sourcePc = document.createElement("source");
  sourcePc.srcset = bannerItem["image-pc"];
  sourcePc.media = "(min-width: 768px)";
  picture.appendChild(sourcePc);

  // Mobile source
  const sourceMobile = document.createElement("source");
  sourceMobile.srcset = bannerItem["image-mobile"];
  sourceMobile.media = "(max-width: 767px)";
  picture.appendChild(sourceMobile);

  // Fallback img
  const img = document.createElement("img");
  img.className = "fsi-w-full fsi-banner-image";
  img.src = bannerItem["image-pc"];
  img.alt = bannerItem.title?.content || "Banner Image";
  picture.appendChild(img);

  return picture;
}

// ===================== 创建幻灯片内容 =====================
function createSlideContent(bannerItem) {
  const contentWrapper = document.createElement("div");
  contentWrapper.className = "fsi-slide-content";

  if (bannerItem["sub-title"]?.content) {
    const subTitle = document.createElement("div");
    subTitle.className = "fsi-sub-title no-select";
    subTitle.textContent = bannerItem["sub-title"].content;
    subTitle.style.color = bannerItem["sub-title"].color || "#000";
    contentWrapper.appendChild(subTitle);
  }

  if (bannerItem.title?.content) {
    const title = document.createElement("h2");
    title.className = "fsi-title no-select";
    title.textContent = bannerItem.title.content;
    title.style.color = bannerItem.title.color || "#000";
    contentWrapper.appendChild(title);
  }

  if (bannerItem.description?.content) {
    const description = document.createElement("p");
    description.className = "fsi-description no-select";
    description.textContent = bannerItem.description.content;
    description.style.color = bannerItem.description.color || "#000";
    contentWrapper.appendChild(description);
  }

  const buttonsContainer = document.createElement("div");
  buttonsContainer.className = "fsi-buttons-container";

  if (bannerItem["botton-first"]?.text) {
    const firstButton = document.createElement("a");
    firstButton.className = "fsi-button fsi-first-button no-select";
    firstButton.textContent = bannerItem["botton-first"].text;
    firstButton.href = bannerItem["botton-first"].url;
    firstButton.style.backgroundColor = bannerItem["botton-first"].background || "#129CFF";
    firstButton.style.color = bannerItem["botton-first"].color || "#fff";
    buttonsContainer.appendChild(firstButton);
  }

  if (bannerItem["botton-second"]?.text) {
    const secondButton = document.createElement("a");
    secondButton.className = "fsi-button fsi-second-button no-select";
    secondButton.textContent = bannerItem["botton-second"].text;
    secondButton.href = bannerItem["botton-second"].url;
    secondButton.style.backgroundColor = bannerItem["botton-second"].background || "#fff";
    secondButton.style.color = bannerItem["botton-second"].color || "#101010";
    buttonsContainer.appendChild(secondButton);
  }

  if (buttonsContainer.children.length > 0) {
    contentWrapper.appendChild(buttonsContainer);
  }

  return contentWrapper;
}

// ===================== 创建幻灯片 =====================
function createSlideElement(bannerItem) {
  const slide = document.createElement("div");
  slide.className = "fsi-hp-slide";
  slide.appendChild(createPictureElement(bannerItem));
  slide.appendChild(createSlideContent(bannerItem));
  return slide;
}

// ===================== 渲染幻灯片 =====================
function createSlides() {
  if(!slideshow){return;}
  slideshow.innerHTML = "";

  const slides = [];
  slides.push(createSlideElement(bannerData[bannerData.length - 1])); // 最后克隆

  bannerData.forEach(item => slides.push(createSlideElement(item))); // 正常幻灯片
  slides.push(createSlideElement(bannerData[0])); // 第一克隆

  slides.forEach(slide => slideshow.appendChild(slide));
  slideshow.style.transform = `translateX(-${currentIndex * 100}%)`;
}

// ===================== 分页 =====================
function setupPagination() {
  if(!pagination){return;}
  pagination.innerHTML = "";
  bannerData.forEach((_, i) => {
    const dot = document.createElement("div");
    dot.className = "dot";
    if (i === 0) dot.classList.add("active");
    dot.addEventListener("click", () => goToSlide(i + 1));
    pagination.appendChild(dot);
  });
}

function updatePagination() {
  const dots = document.querySelectorAll(".dot");
  if (dots.length === 0) {return;}
  dots.forEach(dot => dot.classList.remove("active"));
  const visibleIndex = (currentIndex - 1 + bannerData.length) % bannerData.length;
  dots[visibleIndex].classList.add("active");
}

// ===================== 幻灯片控制 =====================
function goToSlide(i) {
  if (isAnimating) return;
  currentIndex = i;
  animateSlide();
}

function animateSlide() {
  if(!slideshow){return;}
  isAnimating = true;
  slideshow.style.transition = "transform 0.5s ease-in-out";
  slideshow.style.transform = `translateX(-${currentIndex * 100}%)`;
  updatePagination();
  resetAutoPlay();
}

function nextSlide() { if (isAnimating) return; currentIndex++; animateSlide(); }
function prevSlide() { if (isAnimating) return; currentIndex--; animateSlide(); }

function handleTransitionEnd() {
  if (currentIndex === 0) {
    slideshow.style.transition = "none";
    currentIndex = bannerData.length;
    slideshow.style.transform = `translateX(-${currentIndex * 100}%)`;
  } else if (currentIndex === bannerData.length + 1) {
    slideshow.style.transition = "none";
    currentIndex = 1;
    slideshow.style.transform = `translateX(-${currentIndex * 100}%)`;
  }
  isAnimating = false;
}

// ===================== 自动播放 =====================
function startAutoPlay() {
  intervalId = setInterval(nextSlide, 8000);
}
function resetAutoPlay() {
  clearInterval(intervalId);
  startAutoPlay();
}

// ===================== 滑动支持 =====================
function addSwipeSupport() {
  if(!slideshow){return;}
  let startX = 0, endX = 0, isMouseDown = false, mouseStartX = 0;

  slideshow.addEventListener("touchstart", e => startX = e.touches[0].clientX);
  slideshow.addEventListener("touchend", e => {
    endX = e.changedTouches[0].clientX;
    const delta = endX - startX;
    if (Math.abs(delta) > 50) delta > 0 ? prevSlide() : nextSlide();
  });

  slideshow.addEventListener("mousedown", e => { isMouseDown = true; mouseStartX = e.clientX; });
  document.addEventListener("mouseup", e => {
    if (!isMouseDown) return;
    isMouseDown = false;
    const delta = e.clientX - mouseStartX;
    if (Math.abs(delta) > 50) delta > 0 ? prevSlide() : nextSlide();
  });
}

// ===================== preload 首张 banner =====================
function preloadFirstBanner(callback) {
  const firstImg = new Image();
  firstImg.src = bannerData[0]["image-pc"];
  firstImg.onload = callback;
}

// ===================== 初始化 =====================
function initBanner() {
  preloadFirstBanner(() => {
    createSlides();
    setupPagination();
    updatePagination();
    addSwipeSupport();
    startAutoPlay();

    if(nextBtn){nextBtn.addEventListener("click", nextSlide);}
    if(prevBtn){prevBtn.addEventListener("click", prevSlide);}
    if(slideshow){slideshow.addEventListener("transitionend", handleTransitionEnd);}
  });
}

// window.addEventListener("load", init);
<!-- ============================================================================= -->


<!-- 点击复制折扣码 Start -->
var couponWapper = document.getElementById("coupon-wapper");
if(couponWapper){
  document.getElementById("coupon-wapper").addEventListener("click", function() {
    // 获取子元素 id 为 coupon-code 的 strong 标签
    var couponCode = document.getElementById("coupon-code").textContent.trim();
    
    // 尝试使用 Clipboard API
    if (navigator.clipboard) {
      // 确保 Clipboard API 在正确的用户交互上下文中调用
      navigator.clipboard.writeText(couponCode).then(function() {
        showTooltip("Coupon " + couponCode + " copied successfully!");
      }).catch(function(error) {
        console.error("Clipboard API copy failed: ", error);
        fallbackCopyText(couponCode);
      });
    } else {
      fallbackCopyText(couponCode);  // 如果 Clipboard API 不可用，使用 execCommand 作为回退
    }
  });
}

// 复制失败时的回退方案，使用 document.execCommand
function fallbackCopyText(text) {
  // 创建一个临时文本框元素
  var textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = 'absolute'; // 防止在页面中显示
  textarea.style.opacity = 0;
  document.body.appendChild(textarea);
  textarea.select(); // 选中文本
  try {
    // 执行复制命令
    var successful = document.execCommand('copy');  
    if (successful) {
      showTooltip("Coupon " + text + " copied successfully!");
    } else {
      showTooltip("Copy failed, please copy manually.");
    }
  } catch (err) {
    console.error("Copy failed: ", err);
    showTooltip("Copy failed, please copy manually.");
  }
  document.body.removeChild(textarea);
}

// 显示折扣码复制成功提示信息
function showTooltip(message) {
  let tooltip = document.createElement("div");
  tooltip.className = "tooltip";
  tooltip.innerText = message;
  document.body.appendChild(tooltip);
  setTimeout(() => tooltip.style.opacity = 1, 10);
  setTimeout(() => {
    tooltip.style.opacity = 0;
    setTimeout(() => tooltip.remove(), 500);
  }, 2000);
}
<!-- 点击复制折扣码 End -->

// 唤起inbox窗口，在链接中填写#chat即可
window.ac = window.ac || {} 
ac.chatLink = document.querySelector("a[href='#chat']");

if (ac.chatLink) { 
  ac.chatLink.addEventListener("click", function(e) { 
    e.preventDefault(); 
    e.stopPropagation(); 

    document.getElementById("ShopifyChat").shadowRoot.querySelector("button.chat-toggle").click(); 
  }); 
}